/**
 * Max queries to fetch on the Queries Tab
 */
export const MAX_QUERIES_COUNT = 1000;
/**
 * Default page size for Queries Tab Section
 */
export const DEFAULT_PAGE_SIZE = 6;
/**
 * The Max number of "Recent Queries" to surface.
 */
export const DEFAULT_MAX_RECENT_QUERIES = 9;

/**
 * Searching Queries
 */
export const MAX_ROWS_BEFORE_DEBOUNCE = 50;
export const HALF_SECOND_IN_MS = 500;

export const ADD_UNAUTHORIZED_MESSAGE = 'You are not authorized to add Queries to this entity.';
